import { Col } from "@amzn/stencil-react-components/layout";
import { Link } from "@amzn/stencil-react-components/link";
import { Text } from "@amzn/stencil-react-components/text";
import React from "react";
import { FormattedMessage } from "react-intl";

import { IT_SUPPORT_LINK } from "@/components/ErrorBoundary";
/**
 * A component that displays an error message when FAQ content fails to load
 */
export const ErrorLoadingFAQ = () => (
  <Col gridGap="S300" data-test-id="faq-loading-error-container">
    <Text color="error" data-test-id="failedToRender">
      <FormattedMessage
        id="failedToRender"
        values={{
          link: (
            <Link
              href={IT_SUPPORT_LINK}
              target="_blank"
              rel="noopener noreferrer"
            >
              {IT_SUPPORT_LINK}
            </Link>
          ),
        }}
      />
    </Text>
  </Col>
);
